import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { TenantsActions } from './tenants.actions';
import { TenantService } from '../../services/tenant.service';

@Injectable()
export class TenantsEffects {
  private actions$ = inject(Actions);
  private service = inject(TenantService);

  loadTenants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantsActions.loadTenants),
      mergeMap(() =>
        this.service.getAll().pipe(
          map(tenants => TenantsActions.loadTenantsSuccess({ tenants })),
          catchError(err => of(TenantsActions.loadTenantsFailure({ error: err.message })))
        )
      )
    )
  );

  createTenant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantsActions.createTenant),
      mergeMap(({ data }) =>
        this.service.create(data).pipe(
          map(tenant => TenantsActions.createTenantSuccess({ tenant })),
          catchError(err => of(TenantsActions.createTenantFailure({ error: err.message })))
        )
      )
    )
  );

  setTenantActive$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantsActions.setTenantActive),
      mergeMap(({ id, isActive }) =>
        this.service.setActive(id, isActive).pipe(
          map(tenant => TenantsActions.setTenantActiveSuccess({ tenant })),
          catchError(err => of(TenantsActions.setTenantActiveFailure({ error: err.message })))
        )
      )
    )
  );

  loadTenantAdmins$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantsActions.loadTenantAdmins),
      mergeMap(({ tenantId }) =>
        this.service.getAdmins(tenantId).pipe(
          map(admins => TenantsActions.loadTenantAdminsSuccess({ admins })),
          catchError(err => of(TenantsActions.loadTenantAdminsFailure({ error: err.message })))
        )
      )
    )
  );

  createTenantAdmin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantsActions.createTenantAdmin),
      mergeMap(({ tenantId, data }) =>
        this.service.createAdmin(tenantId, data).pipe(
          map(admin => TenantsActions.createTenantAdminSuccess({ admin })),
          catchError(err => of(TenantsActions.createTenantAdminFailure({ error: err.message })))
        )
      )
    )
  );

  removeTenantAdmin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantsActions.removeTenantAdmin),
      mergeMap(({ tenantId, personnelId }) =>
        this.service.removeAdmin(tenantId, personnelId).pipe(
          map(() => TenantsActions.removeTenantAdminSuccess({ personnelId })),
          catchError(err => of(TenantsActions.removeTenantAdminFailure({ error: err.message })))
        )
      )
    )
  );
}
